
export const businesses = [
  {
    id: "computing-power",
    icon: "ri-server-fill",
    title: "算力投资运营",
    description: "面向数据中心与算力基础设施的投资布局与专业化运营管理，为AI训练、推理及大规模计算任务提供稳定、高效的算力资源保障。",
    image: "https://public.readdy.ai/ai/img_res/430efc3e8bf5badd01780283aeb62579.jpg",
    heroBg: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20a%20massive%20modern%20data%20center%20facility%20with%20thousands%20of%20high%20performance%20computing%20servers%20in%20neat%20rows%2C%20cool%20blue%20LED%20lighting%20reflecting%20off%20polished%20floors%2C%20cable%20management%20systems%20overhead%2C%20representing%20enterprise%20grade%20computing%20power%20infrastructure%20investment%20and%20operations&width=1400&height=600&seq=compute-hero1&orientation=landscape",
    detailIntro: "龙创未来算力投资运营业务聚焦于数据中心与算力基础设施的全生命周期管理，从选址规划、建设投资到日常运营维护，为客户提供一站式算力资源保障服务。我们依托先进的能效管理技术和智能运维体系，确保算力资源的高可用性与低能耗运行。",
    highlights: [
      { label: "数据中心规模", value: "10,000+", unit: "机柜" },
      { label: "算力总量", value: "500+", unit: "PFLOPS" },
      { label: "PUE能效比", value: "1.15", unit: "" },
      { label: "服务可用率", value: "99.99", unit: "%" }
    ],
    features: [
      {
        title: "智能选址与规划",
        desc: "基于气候、电力、网络等多维度数据分析，科学选址并规划数据中心建设方案，降低建设成本与运营能耗。",
        icon: "ri-map-pin-2-line"
      },
      {
        title: "绿色节能运营",
        desc: "采用液冷散热、自然冷源利用、智能温控等先进技术，实现PUE低至1.15的绿色高效运营。",
        icon: "ri-leaf-line"
      },
      {
        title: "弹性算力调度",
        desc: "自研算力调度平台，支持GPU/CPU资源的灵活分配与动态扩缩容，满足AI训练与推理的多样化需求。",
        icon: "ri-cpu-line"
      },
      {
        title: "全栈安全保障",
        desc: "物理安全、网络安全、数据安全三位一体防护体系，通过等保三级认证，确保客户数据万无一失。",
        icon: "ri-shield-check-line"
      }
    ],
    cases: [
      { title: "某省级AI算力中心", desc: "为省级人工智能算力中心提供从规划到运营的全流程服务，部署超过2000台GPU服务器，支撑区域AI产业发展。" },
      { title: "大型互联网企业算力托管", desc: "为头部互联网企业提供定制化算力托管服务，年均节省运营成本超30%，算力利用率提升至85%以上。" }
    ]
  },
  {
    id: "ai-equipment",
    icon: "ri-robot-line",
    title: "人工智能产品装备研发",
    description: "自主研发面向行业场景的AI产品与智能装备，涵盖智能识别终端、AI边缘设备及行业专用智能硬件，推动AI技术从算法到实体产品的落地转化。",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20AI-powered%20smart%20device%20and%20intelligent%20equipment%20with%20circuit%20board%20details%20and%20glowing%20elements%20on%20clean%20minimalist%20white%20background%2C%20representing%20artificial%20intelligence%20product%20development&width=600&height=400&seq=aiproduct1&orientation=landscape",
    heroBg: "https://readdy.ai/api/search-image?query=Advanced%20AI%20robotics%20laboratory%20with%20intelligent%20equipment%20prototypes%20and%20smart%20devices%20being%20assembled%20on%20workbenches%2C%20clean%20high%20tech%20research%20and%20development%20environment%20with%20engineers%20working%20on%20cutting%20edge%20artificial%20intelligence%20hardware%20products&width=1400&height=600&seq=aiequip-hero1&orientation=landscape",
    detailIntro: "龙创未来人工智能产品装备研发业务致力于将前沿AI算法与硬件工程深度融合，打造面向工业、安防、医疗、教育等行业的智能终端与装备产品。我们拥有完整的从算法研发、硬件设计、嵌入式开发到量产交付的全链条能力。",
    highlights: [
      { label: "自研AI产品", value: "30+", unit: "款" },
      { label: "发明专利", value: "80+", unit: "项" },
      { label: "行业覆盖", value: "12+", unit: "个" },
      { label: "年出货量", value: "50,000+", unit: "台" }
    ],
    features: [
      {
        title: "AI视觉识别终端",
        desc: "集成自研视觉算法的智能识别设备，支持人脸识别、物体检测、缺陷检测等多场景应用，识别准确率达99.5%以上。",
        icon: "ri-eye-line"
      },
      {
        title: "AI边缘计算设备",
        desc: "高性能低功耗的边缘AI计算盒子，支持多路视频流实时分析，适用于工厂、园区、交通等场景的本地化智能处理。",
        icon: "ri-box-3-line"
      },
      {
        title: "智能机器人平台",
        desc: "模块化智能机器人开发平台，支持巡检、配送、导览等多种应用场景，具备自主导航、语音交互、环境感知能力。",
        icon: "ri-robot-2-line"
      },
      {
        title: "行业定制化开发",
        desc: "根据客户特定需求，提供从需求分析、方案设计到产品交付的定制化AI装备开发服务，快速响应行业痛点。",
        icon: "ri-tools-line"
      }
    ],
    cases: [
      { title: "智慧矿山AI安全装备", desc: "为大型矿业集团研发部署AI安全监测装备，实现矿井环境实时监控与危险预警，事故率降低90%。" },
      { title: "智能质检设备", desc: "为电子制造企业定制AI视觉质检设备，检测速度提升5倍，漏检率降至0.01%以下。" }
    ]
  },
  {
    id: "industrial-digital",
    icon: "ri-factory-line",
    title: "工业数字化",
    description: "工业互联网平台、数字孪生、预测性维护、智能排产与质量检测等工业AI应用，助力制造企业提质增效、绿色低碳转型。",
    image: "https://readdy.ai/api/search-image?query=Smart%20factory%20digital%20twin%20visualization%20with%20robotic%20arms%20and%20real-time%20production%20data%20analytics%20on%20clean%20industrial%20background%2C%20representing%20Industry%204.0%20digital%20transformation&width=600&height=400&seq=industry2&orientation=landscape",
    heroBg: "https://readdy.ai/api/search-image?query=Futuristic%20smart%20factory%20interior%20with%20digital%20twin%20holographic%20displays%20showing%20real%20time%20production%20data%2C%20robotic%20assembly%20lines%20with%20automated%20quality%20inspection%20systems%2C%20clean%20modern%20industrial%20environment%20representing%20Industry%204.0%20digital%20transformation&width=1400&height=600&seq=industry-hero1&orientation=landscape",
    detailIntro: "龙创未来工业数字化业务以工业互联网平台为核心，融合物联网、大数据、人工智能与数字孪生技术，为制造企业提供从设备层到管理层的全方位数字化转型解决方案，助力企业实现智能制造与精益管理。",
    highlights: [
      { label: "服务工厂", value: "200+", unit: "家" },
      { label: "设备接入", value: "50,000+", unit: "台" },
      { label: "平均提效", value: "35", unit: "%" },
      { label: "降本幅度", value: "25", unit: "%" }
    ],
    features: [
      {
        title: "工业互联网平台",
        desc: "自研工业互联网平台，支持多协议设备接入、数据采集与可视化分析，实现生产全流程的数字化管控。",
        icon: "ri-global-line"
      },
      {
        title: "数字孪生系统",
        desc: "构建工厂级数字孪生模型，实时映射物理产线状态，支持仿真优化、远程监控与异常预警。",
        icon: "ri-3d-cude-sphere-line"
      },
      {
        title: "AI质量检测",
        desc: "基于深度学习的视觉质检系统，替代人工目检，实现产品缺陷的自动识别与分类，检测效率提升10倍。",
        icon: "ri-search-eye-line"
      },
      {
        title: "智能排产优化",
        desc: "AI驱动的智能排产系统，综合考虑订单、产能、物料等约束条件，自动生成最优生产计划。",
        icon: "ri-calendar-schedule-line"
      }
    ],
    cases: [
      { title: "某汽车零部件工厂数字化", desc: "为大型汽车零部件制造商实施全厂数字化改造，生产效率提升40%，不良品率降低60%。" },
      { title: "食品加工智能工厂", desc: "为食品加工企业打造智能工厂解决方案，实现从原料到成品的全程可追溯，产能提升30%。" }
    ]
  },
  {
    id: "smart-city",
    icon: "ri-building-2-line",
    title: "智慧城市",
    description: "城市大脑、交通治理、公共安全、应急指挥与城市运行管理数字化解决方案，助力城市治理精细化与公共服务智能化升级。",
    image: "https://readdy.ai/api/search-image?query=Smart%20city%20aerial%20view%20with%20intelligent%20traffic%20management%20and%20urban%20data%20visualization%20dashboard%20on%20clean%20modern%20background%2C%20representing%20digital%20city%20governance%20and%20public%20safety&width=600&height=400&seq=city2&orientation=landscape",
    heroBg: "https://readdy.ai/api/search-image?query=Panoramic%20smart%20city%20skyline%20at%20dusk%20with%20interconnected%20digital%20infrastructure%20visualization%2C%20intelligent%20traffic%20flow%20management%20systems%2C%20urban%20IoT%20sensor%20networks%20and%20holographic%20city%20data%20dashboard%20overlay%2C%20representing%20next%20generation%20smart%20city%20governance%20platform&width=1400&height=600&seq=city-hero1&orientation=landscape",
    detailIntro: "龙创未来智慧城市业务以城市大脑为核心平台，整合交通、安防、环保、应急等多领域数据与AI能力，为城市管理者提供全域感知、智能决策、精准治理的一体化解决方案，推动城市治理现代化。",
    highlights: [
      { label: "服务城市", value: "15+", unit: "个" },
      { label: "接入设备", value: "100,000+", unit: "台" },
      { label: "日处理数据", value: "50+", unit: "TB" },
      { label: "事件响应提速", value: "60", unit: "%" }
    ],
    features: [
      {
        title: "城市大脑平台",
        desc: "汇聚城市多源数据，构建统一的城市运行态势感知与智能决策平台，实现跨部门协同治理。",
        icon: "ri-brain-line"
      },
      {
        title: "智慧交通治理",
        desc: "AI驱动的交通信号优化、拥堵预测、违章识别与智能停车管理，提升城市交通运行效率。",
        icon: "ri-traffic-light-line"
      },
      {
        title: "公共安全防控",
        desc: "视频AI分析、人群密度监测、异常行为识别等智能安防能力，构建立体化公共安全防控体系。",
        icon: "ri-shield-star-line"
      },
      {
        title: "应急指挥调度",
        desc: "融合GIS、物联网与AI的应急指挥平台，支持灾害预警、资源调度与现场协同，提升应急响应效率。",
        icon: "ri-alarm-warning-line"
      }
    ],
    cases: [
      { title: "某地级市城市大脑项目", desc: "为地级市建设城市大脑平台，接入12个委办局数据，城市事件处置效率提升65%，市民满意度显著提高。" },
      { title: "智慧交通信号优化", desc: "为省会城市核心区域部署AI交通信号优化系统，高峰期通行效率提升25%，平均通勤时间缩短15分钟。" }
    ]
  },
  {
    id: "system-integration",
    icon: "ri-links-line",
    title: "系统集成",
    description: "软硬件一体化集成、云边协同架构设计与实施、运维保障与持续优化，确保客户系统安全、稳定、可扩展地长期运行。",
    image: "https://readdy.ai/api/search-image?query=Enterprise%20system%20integration%20architecture%20with%20interconnected%20cloud%20servers%20and%20network%20infrastructure%20on%20clean%20minimalist%20background%2C%20representing%20unified%20technology%20platform%20and%20system%20deployment&width=600&height=400&seq=integration2&orientation=landscape",
    heroBg: "https://readdy.ai/api/search-image?query=Modern%20enterprise%20IT%20infrastructure%20with%20interconnected%20server%20racks%20cloud%20computing%20visualization%20and%20network%20topology%20diagrams%2C%20professional%20system%20integration%20environment%20with%20engineers%20monitoring%20unified%20management%20dashboard%2C%20clean%20technology%20aesthetic&width=1400&height=600&seq=integration-hero1&orientation=landscape",
    detailIntro: "龙创未来系统集成业务提供从方案设计、设备选型、部署实施到运维保障的全流程IT系统集成服务。我们具备丰富的大型项目交付经验，能够将不同厂商的软硬件产品有机整合，构建稳定可靠的信息化基础设施。",
    highlights: [
      { label: "项目交付", value: "500+", unit: "个" },
      { label: "合作厂商", value: "50+", unit: "家" },
      { label: "运维设备", value: "30,000+", unit: "台" },
      { label: "客户续约率", value: "95", unit: "%" }
    ],
    features: [
      {
        title: "整体方案设计",
        desc: "根据客户业务需求与IT现状，提供涵盖网络、计算、存储、安全的整体架构设计与选型方案。",
        icon: "ri-draft-line"
      },
      {
        title: "云边协同部署",
        desc: "支持公有云、私有云、混合云及边缘计算的多种部署模式，实现云边端协同的灵活架构。",
        icon: "ri-cloud-line"
      },
      {
        title: "网络与安全集成",
        desc: "企业级网络规划与部署，集成防火墙、入侵检测、数据加密等安全组件，构建纵深防御体系。",
        icon: "ri-lock-line"
      },
      {
        title: "智能运维服务",
        desc: "7×24小时智能运维监控，AI驱动的故障预测与自动修复，确保系统持续稳定运行。",
        icon: "ri-settings-3-line"
      }
    ],
    cases: [
      { title: "某大型企业IT基础设施集成", desc: "为集团型企业完成覆盖全国20个分支机构的IT基础设施集成，实现统一管理与运维，IT运营成本降低40%。" },
      { title: "政务云平台建设", desc: "为市级政务云平台提供系统集成服务，承载50+政务应用系统，服务可用率达99.99%。" }
    ]
  },
  {
    id: "dell-server",
    icon: "ri-computer-line",
    title: "戴尔服务器代理",
    description: "作为戴尔官方授权代理商，提供戴尔全系列服务器、存储及企业级解决方案的销售、部署与售后服务，为企业IT基础设施建设提供专业支撑。",
    image: "https://readdy.ai/api/search-image?query=Dell%20enterprise%20server%20rack%20with%20professional%20hardware%20equipment%20in%20a%20clean%20modern%20data%20center%20environment%2C%20representing%20authorized%20server%20dealership%20and%20enterprise%20IT%20infrastructure%20solutions&width=600&height=400&seq=dell1&orientation=landscape",
    heroBg: "https://readdy.ai/api/search-image?query=Premium%20Dell%20PowerEdge%20server%20hardware%20showcase%20in%20a%20professional%20enterprise%20data%20center%20environment%20with%20clean%20organized%20server%20racks%20and%20professional%20lighting%2C%20representing%20Dell%20authorized%20partner%20and%20enterprise%20server%20solutions&width=1400&height=600&seq=dell-hero1&orientation=landscape",
    detailIntro: "龙创未来作为戴尔科技集团官方授权合作伙伴，深耕企业级IT基础设施领域多年，为客户提供戴尔全系列服务器、存储、网络及数据保护产品的专业销售、方案设计、部署实施与售后维保服务。",
    highlights: [
      { label: "合作年限", value: "10+", unit: "年" },
      { label: "年销售额", value: "2亿+", unit: "元" },
      { label: "服务客户", value: "1,000+", unit: "家" },
      { label: "售后响应", value: "4", unit: "小时" }
    ],
    features: [
      {
        title: "全系列产品覆盖",
        desc: "涵盖Dell PowerEdge服务器、PowerStore存储、PowerSwitch网络及PowerProtect数据保护全产品线。",
        icon: "ri-stack-line"
      },
      {
        title: "专业方案咨询",
        desc: "拥有多名戴尔认证技术专家，根据客户业务场景提供最优的产品选型与架构设计方案。",
        icon: "ri-user-star-line"
      },
      {
        title: "快速部署交付",
        desc: "本地化备货与专业部署团队，支持标准化与定制化配置，确保设备快速上架投入使用。",
        icon: "ri-rocket-line"
      },
      {
        title: "全生命周期服务",
        desc: "从售前咨询、安装调试到售后维保、扩容升级，提供设备全生命周期的专业技术服务。",
        icon: "ri-loop-right-line"
      }
    ],
    cases: [
      { title: "某银行数据中心服务器采购", desc: "为区域性银行数据中心提供200+台Dell PowerEdge服务器及配套存储设备，支撑核心业务系统稳定运行。" },
      { title: "高校HPC集群建设", desc: "为重点高校建设高性能计算集群，部署Dell PowerEdge C系列服务器，满足科研计算需求。" }
    ]
  },
  {
    id: "hardware-sales",
    icon: "ri-hard-drive-2-line",
    title: "硬件销售",
    description: "面向企业客户提供计算机硬件、网络设备、存储设备及外围设备的专业销售与选型咨询服务，满足不同规模企业的IT采购需求。",
    image: "https://readdy.ai/api/search-image?query=Professional%20enterprise%20hardware%20products%20including%20servers%20network%20switches%20and%20storage%20devices%20arranged%20neatly%20on%20clean%20white%20background%2C%20representing%20B2B%20hardware%20sales%20and%20IT%20procurement&width=600&height=400&seq=hardware1&orientation=landscape",
    heroBg: "https://readdy.ai/api/search-image?query=Professional%20enterprise%20IT%20hardware%20showroom%20with%20servers%20workstations%20network%20equipment%20and%20storage%20devices%20displayed%20in%20a%20clean%20modern%20exhibition%20space%2C%20representing%20comprehensive%20B2B%20hardware%20sales%20and%20procurement%20solutions&width=1400&height=600&seq=hardware-hero1&orientation=landscape",
    detailIntro: "龙创未来硬件销售业务整合国内外主流IT硬件品牌资源，为企业客户提供一站式硬件采购服务。我们不仅提供有竞争力的价格，更注重专业的选型咨询与售后保障，帮助企业构建高性价比的IT基础设施。",
    highlights: [
      { label: "合作品牌", value: "30+", unit: "个" },
      { label: "SKU数量", value: "5,000+", unit: "个" },
      { label: "年出货量", value: "100,000+", unit: "台" },
      { label: "客户满意度", value: "98", unit: "%" }
    ],
    features: [
      {
        title: "多品牌全品类",
        desc: "涵盖Dell、HP、Lenovo、华为等主流品牌的服务器、PC、网络设备、存储及外设全品类产品。",
        icon: "ri-shopping-bag-line"
      },
      {
        title: "专业选型服务",
        desc: "资深技术顾问团队，根据客户应用场景与预算，提供最优性价比的硬件选型与配置建议。",
        icon: "ri-file-list-3-line"
      },
      {
        title: "供应链保障",
        desc: "与各大品牌厂商建立深度合作关系，确保货源充足、价格优势，支持大批量采购与紧急调货。",
        icon: "ri-truck-line"
      },
      {
        title: "增值服务",
        desc: "提供硬件安装部署、系统预装、资产管理、延保服务等增值服务，降低客户IT管理负担。",
        icon: "ri-service-line"
      }
    ],
    cases: [
      { title: "某集团企业年度IT采购", desc: "为大型集团企业提供年度IT硬件集中采购服务，覆盖PC、服务器、网络设备等，采购成本节省15%。" },
      { title: "教育行业批量采购", desc: "为多所学校提供教学终端与网络设备批量采购，配合完成部署与培训，项目按期交付率100%。" }
    ]
  },
  {
    id: "supply-chain",
    icon: "ri-git-repository-line",
    title: "集团硬件供应链平台",
    description: "构建覆盖采购、仓储、配送与售后的一体化硬件供应链管理平台，整合上下游资源，为集团及合作伙伴提供高效、透明、可追溯的供应链服务。",
    image: "https://readdy.ai/api/search-image?query=Modern%20supply%20chain%20management%20platform%20with%20logistics%20network%20visualization%20and%20warehouse%20automation%20on%20clean%20technology%20background%2C%20representing%20integrated%20hardware%20supply%20chain%20operations&width=600&height=400&seq=supplychain1&orientation=landscape",
    heroBg: "https://readdy.ai/api/search-image?query=Advanced%20supply%20chain%20management%20center%20with%20large%20digital%20screens%20showing%20logistics%20tracking%20maps%20warehouse%20inventory%20dashboards%20and%20automated%20sorting%20systems%2C%20modern%20clean%20technology%20operations%20center%20representing%20integrated%20hardware%20supply%20chain%20platform&width=1400&height=600&seq=supply-hero1&orientation=landscape",
    detailIntro: "龙创未来集团硬件供应链平台是面向集团型企业与渠道合作伙伴的一体化供应链管理系统，通过数字化手段打通采购、仓储、物流、售后全链条，实现供应链的可视化、智能化与高效协同。",
    highlights: [
      { label: "平台用户", value: "500+", unit: "家" },
      { label: "日均订单", value: "2,000+", unit: "单" },
      { label: "仓储面积", value: "20,000+", unit: "㎡" },
      { label: "配送时效", value: "24", unit: "小时" }
    ],
    features: [
      {
        title: "智能采购管理",
        desc: "AI驱动的需求预测与智能补货系统，自动生成最优采购计划，降低库存积压与缺货风险。",
        icon: "ri-shopping-cart-line"
      },
      {
        title: "数字化仓储",
        desc: "WMS仓储管理系统，支持条码/RFID管理、智能分拣与库位优化，仓储作业效率提升50%。",
        icon: "ri-building-4-line"
      },
      {
        title: "全程物流追踪",
        desc: "集成主流物流平台，实现订单从下单到签收的全程可视化追踪，客户随时掌握物流动态。",
        icon: "ri-route-line"
      },
      {
        title: "数据分析决策",
        desc: "多维度供应链数据分析看板，支持销售趋势、库存周转、供应商绩效等关键指标的实时监控与决策支持。",
        icon: "ri-bar-chart-box-line"
      }
    ],
    cases: [
      { title: "某集团供应链数字化转型", desc: "为大型企业集团搭建统一的硬件供应链平台，整合全国8个仓储中心，订单处理效率提升70%，库存周转率提高40%。" },
      { title: "渠道合作伙伴赋能", desc: "为200+渠道合作伙伴提供供应链平台接入服务，实现订单自动化处理与实时库存共享，渠道满意度提升至96%。" }
    ]
  }
];
